/* ==========================================================================
   Natuliv PDP desktop layout
   1) Gallery rail (correcciones #18): Horizon's stacked one-column gallery has no
      thumbnails, so we build a rail with one thumb per gallery image next to the stack;
      clicking scrolls the stack to that image. When there are more thumbs than fit, the
      rail scrolls on its own and keeps the active thumb in view. The rail sits in a full-height track and is
      sticky inside it, so it stays on screen while the stack scrolls.
   2) Two-column scroll: both columns (gallery, product details) are sticky with a
      top computed from their own height. A column shorter than the viewport sticks
      under the header; a taller one scrolls with the page until its bottom edge is
      reached and then sticks there. Each column can be read to its end, and the
      section ends when the taller one does.
   Desktop only; mobile keeps Horizon's slideshow + dots and normal flow.
   ========================================================================== */
(function () {
  'use strict';

  function build(gallery) {
    if (gallery.dataset.nvRail) return;
    // only the stacked grid items (the mobile slideshow copies live outside .media-gallery__grid)
    var items = gallery.querySelectorAll('.media-gallery__grid > li');
    if (!items.length) return;
    gallery.dataset.nvRail = '1';
    var rail = document.createElement('div');
    rail.className = 'nv-rail';
    rail.setAttribute('aria-label', 'Miniaturas');
    var count = 0;
    for (var i = 0; i < items.length; i++) {
      var img = items[i].querySelector('img');
      if (!img) continue;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nv-rail__thumb' + (count === 0 ? ' is-active' : '');
      btn.setAttribute('aria-label', 'Imagen ' + (count + 1));
      var t = document.createElement('img');
      t.src = img.currentSrc || img.src;
      t.alt = '';
      t.loading = 'lazy';
      btn.appendChild(t);
      btn.dataset.nvIndex = String(i);
      (function (target, b) {
        b.addEventListener('click', function () {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          rail.querySelectorAll('.nv-rail__thumb').forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
        });
      })(items[i], btn);
      rail.appendChild(btn);
      count++;
    }
    if (count < 2) return;
    gallery.classList.add('nv-has-rail');
    var track = document.createElement('div');
    track.className = 'nv-rail-track';
    track.appendChild(rail);
    gallery.insertBefore(track, gallery.firstChild);

    // Keep the active thumb in sync while scrolling the stack (and visible inside the rail).
    // Active = the image whose box covers the viewport's center line; at the end of the stack
    // (sticky column, last image may never reach the center) the last visible image wins.
    var thumbs = rail.querySelectorAll('.nv-rail__thumb');
    var current = null;
    var sync = function () {
      if (!desktop.matches) return;
      var mid = window.innerHeight / 2;
      var pick = null;
      for (var j = 0; j < thumbs.length; j++) {
        var r = items[Number(thumbs[j].dataset.nvIndex)].getBoundingClientRect();
        if (r.top <= mid) pick = thumbs[j];
        if (r.bottom <= window.innerHeight + 1 && j === thumbs.length - 1 && r.bottom > 0) pick = thumbs[j];
      }
      pick = pick || thumbs[0];
      if (pick === current) return;
      current = pick;
      thumbs.forEach(function (x) { x.classList.toggle('is-active', x === pick); });
      if (rail.scrollHeight > rail.clientHeight) {
        var top = pick.offsetTop;
        if (top < rail.scrollTop || top + pick.offsetHeight > rail.scrollTop + rail.clientHeight) {
          var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          rail.scrollTo({ top: top - (rail.clientHeight - pick.offsetHeight) / 2, behavior: calm ? 'auto' : 'smooth' });
        }
      }
    };
    var queued = false;
    var onScroll = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; sync(); });
    };
    // desktop scrolls .page-wrapper (html overflow is hidden); capture catches either scroller
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    window.addEventListener('resize', onScroll);
    rail.nvSync = sync;
    sync();
  }

  /* ---------------- two-column sticky ---------------- */
  var desktop = window.matchMedia('(min-width: 750px)');
  var GAP_TOP = 16;
  var GAP_BOTTOM = 24;

  function headerOffset() {
    var h = document.getElementById('header-component');
    return (h ? h.getBoundingClientRect().height : 72) + GAP_TOP;
  }

  function viewportHeight() {
    // Horizon scrolls .page-wrapper on desktop; sticky is relative to that scroller
    var pw = document.querySelector('.page-wrapper');
    if (pw && pw.scrollHeight > pw.clientHeight + 1) return pw.clientHeight;
    return window.innerHeight;
  }

  function fitColumns(grid) {
    var cols = [grid.querySelector('.product-information__media'), grid.querySelector('.product-details')];
    var off = headerOffset();
    var vh = viewportHeight();
    grid.style.setProperty('--nv-rail-top', off + 'px');
    cols.forEach(function (col) {
      if (!col) return;
      var h = col.offsetHeight;
      var top = off + h + GAP_BOTTOM > vh ? vh - h - GAP_BOTTOM : off;
      col.style.setProperty('--nv-col-top', Math.round(top) + 'px');
    });
  }

  function wireColumns(grid) {
    if (grid.dataset.nvColumns) return;
    grid.dataset.nvColumns = '1';
    var raf = 0;
    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        if (desktop.matches) fitColumns(grid);
      });
    }
    // heights change when images load, accordions open or the variant re-renders the details
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(schedule);
      grid.querySelectorAll('.product-information__media, .product-details').forEach(function (c) { ro.observe(c); });
    }
    window.addEventListener('resize', schedule);
    desktop.addEventListener('change', schedule);
    var header = document.getElementById('header-component');
    if (header && 'ResizeObserver' in window) new ResizeObserver(schedule).observe(header);
    schedule();
  }

  function boot() {
    document.querySelectorAll('.nv-template-product .product-information__grid').forEach(wireColumns);
    if (!desktop.matches) return;
    document.querySelectorAll('.media-gallery--grid').forEach(function (g) {
      build(g.closest('media-gallery') || g.parentElement || g);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
